import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationNone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAnimationNone"><Path fillRule="evenodd" clipRule="evenodd" d="M11.5 3.5C11.5 3.22386 11.7239 3 12 3H20.5C20.7761 3 21 3.22386 21 3.5C21 3.77614 20.7761 4 20.5 4H12.5V20.5C12.5 20.7761 12.2761 21 12 21H3.5C3.22386 21 3 20.7761 3 20.5C3 20.2239 3.22386 20 3.5 20H11.5V3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationNone;
